import '@/assets/main.scss'
import { useAuthStore } from '@/stores/auth'
import { createPinia, PiniaVuePlugin } from 'pinia'
import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { appCheck, auth, database, functions } from './plugins/firebaseClient'
import vuetify from './plugins/vuetify'
import router from './router'

// Disable production tip
Vue.config.productionTip = false

// Setup Pinia
Vue.use(PiniaVuePlugin)
const pinia = createPinia()

// Create Firebase plugin
const firebasePlugin = {
	install(Vue) {
		Vue.prototype.$firebase = {
			auth,
			database,
			functions,
			appCheck,
		}
	},
}

// Setup Firebase plugin
Vue.use(firebasePlugin)

const app = new Vue({
	pinia,
	router,
	i18n,
	vuetify,
	render: h => h(App),
})

auth.onAuthStateChanged(async user => {
	const authStore = useAuthStore()
	await authStore.initializeUser(user)
	// Mount app after auth is initialized
	app.$mount('#app')
})
